export const localText = {
  clearAll: 'Clear all filters',
} as const
